import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";

const DealerOrderListTable = () => {
  const orders = [
    { id: 1, dealer: "Dealer A", product: "Product 1", quantity: 10, date: "2023-10-01" },
    { id: 2, dealer: "Dealer B", product: "Product 2", quantity: 5, date: "2023-10-02" },
    { id: 3, dealer: "Dealer C", product: "Product 3", quantity: 20, date: "2023-10-03" },
  ];

  return (
    <TableContainer component={Paper} sx={{ marginTop: 4, padding: 2 }}>
      <Typography variant="h6" gutterBottom>
        Dealer Orders
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Dealer</TableCell>
            <TableCell>Product</TableCell>
            <TableCell>Quantity</TableCell>
            <TableCell>Date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {orders.map((order) => (
            <TableRow key={order.id}>
              <TableCell>{order.id}</TableCell>
              <TableCell>{order.dealer}</TableCell>
              <TableCell>{order.product}</TableCell>
              <TableCell>{order.quantity}</TableCell>
              <TableCell>{order.date}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DealerOrderListTable;
